import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import MUICheckbox from '@mui/material/Checkbox';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';

import { useTranslation } from 'react-i18next';

import { useTheme } from '@websky/core/src/theme';
import Tooltip from '../../../../../../core/src/BaseComponents/Tooltip';
import { SafeHtml } from '@websky/core/src/__fsd__/shared/ui';

let lastVisibleError = '';

interface Props extends Omit<FormControlLabelProps, 'control'> {
	label: string;
}

const Checkbox: React.FC<Props> = ({ label, name, ...props }) => {
	const { PassengersToolbar: css } = useTheme('Checkout');
	const { t } = useTranslation('Checkout');

	const { input, meta } = useField(name, {
		type: 'checkbox',
		initialValue: false,
		validate: value => {
			if (!value) {
				return t('Please, read the rules of service and accept it');
			}

			return undefined;
		}
	});

	useEffect(() => {
		// safari bug, when checkbox onBlur didn't fired
		// and form didn't update it's state
		input.onBlur();
	}, [input.value]);

	if (meta.error) {
		lastVisibleError = meta.error;
	}

	return (
		<FormControlLabel
			name={name}
			classes={{
				root: css.root,
				label: css.label
			}}
			control={
				<Tooltip open={meta.submitFailed && !input.value} title={lastVisibleError} placement="top-start">
					<MUICheckbox
						color="primary"
						classes={{
							colorPrimary: css.checkbox,
							checked: css.checkbox_checked
						}}
						checked={input.checked}
						inputProps={{ ...input } as any}
					/>
				</Tooltip>
			}
			label={<SafeHtml tag="span" html={label} />}
			{...props}
		/>
	);
};

export default Checkbox;
